"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAssessmentFilters = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAssessmentFilters = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  padding: ", ";\n  color: var(--color-content-hierarchy-prim);\n\n  .reset {\n    color: ", ";\n    font-size: ", ";\n    font-style: normal;\n    font-weight: bold;\n    margin: 20px 0;\n    margin-left: ", ";\n    text-decoration: none;\n\n    i {\n      margin-left: ", ";\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  padding: ", ";\n  color: var(--color-content-hierarchy-prim);\n\n  .reset {\n    color: ", ";\n    font-size: ", ";\n    font-style: normal;\n    font-weight: bold;\n    margin: 20px 0;\n    margin-left: ", ";\n    text-decoration: none;\n\n    i {\n      margin-left: ", ";\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"])), function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x2, " ").concat(Spacing.x3, " ").concat(Spacing.x4);
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Sizes = _a.theme.Typography.Sizes;
    return Sizes.md;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x4;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x1;
});
var templateObject_1;
